<template>
  <div class="privacy-policy-box">
      <title-nav :title="'隐私政策'"/>
      <div class="text" v-for="(item, i) in privacyPolicy" :key="i">
        <div class="title" v-show="item.title.length > 0">{{ item.title }}</div>
        <div class="content">{{  item.content  }}</div>
      </div>
  </div>
</template>

<script>
import TitleNav from '../../components/nav/TitleNav.vue'

export default {
name: 'PrivacyPolicy',
components: {
  TitleNav,
},
mounted(){
},
data:()=>{
  return {
    privacyPolicy:[{
      title:'',
      content:'隐私政策'
    },{
      title:'',
      content:'版本更新日期：2024年11月27日'
    },{
      title:'',
      content:'版本生效日期：2024年12月31日'
    },{
      title:'',
      content:'引言'
    },{
      title:'',
      content:'欢迎您使用绿锋1688，我们非常重视用户的隐私和个人信息保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明在您使用我们的产品或服务时，我们如何收集、使用、保存、共享和转移这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。特别说明，请您在注册登录我们提供的产品或服务服务前，仔细阅读并充分理解本隐私政策，包括但不限于免除或限制我们责任的条款，特别是以粗体标识的条阅读。一旦您使用我们的产品或服务时，即意味着您同意我们按照本隐私政策处理您的个人信息。'
    },{
      title:'',
      content:'本政策将帮助您了解以下内容：'
    },{
      title:'',
      content:'一、我们如何收集和使用您的个人信息'
    },{
      title:'',
      content:'二、我们如何使用 Cookies 和同类技术'
    },{
      title:'',
      content:'三、我们如何共享、转让、公开披露您的信息'
    },{
      title:'',
      content:'四、我们如何保护和保存您的个人信息'
    },{
      title:'',
      content:'五、您如何查阅及管理您的个人信息'
    },{
      title:'',
      content:'六、第三方 SDK 收集使用信息说明'
    },{
      title:'',
      content:'七、未成年人的个人信息保护'
    },{
      title:'',
      content:'八、本隐私政策如何更新'
    },{
      title:'',
      content:'九、如何联系我们'
    },{
      title:'一、我们如何收集和使用您的个人信息',
      content:'我们尊重并保护每位用户的个人信息。个人信息是指以电子或其他方式记录的，与已识别或可识别的自然人有关的信息，但不包括经过匿名化处理的信息。敏感个人信息则指的是一旦泄露或非法使用，可能导致个人尊严受损、人身或财产安全受到威胁的信息，如生物识别数据、宗教信仰、特定身份信息、医疗健康记录、金融账户详情以及不满十四周岁未成年人的个人信息等。'
    },{
      title:'',
      content:'我们承诺遵循正当、合法和必要的原则来收集和使用您在使用我们的产品或服务过程中主动提供的信息，或者因使用产品或服务而产生的信息。此外，我们还可能从第三方获取与您相关的个人信息。如果我们计划将您的个人信息用于本政策未明确说明的其他用途，或基于特定目的收集的信息用于其他目的，我们将通过合理的方式通知您，并在使用前再次征求您的同意。'
    },{
      title:'',
      content:'（一）您须授权我们收集和使用您个人信息的情形'
    },{
      title:'',
      content:'我们的产品或服务包括一些核心功能，这些功能包含了实现网上购物所必须的功能及保障交易安全所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品或服务。这些功能包括：'
    },{
      title:'',
      content:'1.实现网上购物所必须的功能'
    },{
      title:'',
      content:'a.用户账号注册与登录'
    },{
      title:'',
      content:'当您注册绿锋1688账号时，您至少需要向我们提供您准备使用的绿锋1688账号名、密码、手机号码，我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。您的账号名为您的默认昵称，您可以修改和补充您的昵称，这些信息均属于您的“账号信息”。'
    },{
      title:'',
      content:'当您成功注册绿锋1688账号后，可以使用绿锋1688账号登录“绿锋1688”，登录时您需要向我们提供您的绿锋1688账号信息。若您不提供这类信息，您将无法登录和在“绿锋1688”购买商品，此时您可使用浏览和搜索功能，我们将不会收集您的上述个人信息。'
    },{
      title:'',
      content:'b.商品和服务的展示及搜索'
    },{
      title:'',
      content:'我们会向您展示可提供商品/服务、可能会使用通知短信。如您不想接收商业性短信，可以根据短信内容提示，来取消我们给您发送的手机促销短信；'
    },{
      title:'',
      content:'c.下单和订单管理'
    },{
      title:'',
      content:'当您准备对您购物车内的商品进行结算时，绿锋1688系统会生成您购买商品的订单。您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品或服务信息、下单时间、您应支付的货款金额及支付方式；您可以另外填写收货人的联系电话、地址信息以增加更多的联系方式确保商品可以准确送达，但不填写这些信息不影响您订单的生成。若您需要开具发票，请联系人工客服，并主动提供发票抬头、纳税人识别号。'
    },{
      title:'',
      content:'上述所有信息构成您的“订单信息”，我们将使用您的订单信息来（包括与为您提供上述服务的第三方）进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务。我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。'
    },{
      title:'',
      content:'d.支付功能'
    },{
      title:'',
      content:'在您下单后，您可以选择微信支付所提供的支付服务 。我们需要将您的绿锋1688订单号与交易金额信息与微信支付共享以完成下单支付功能。在您使用支付功能时，微信支付会通过其页面收集或验证您的银行卡（含储蓄卡、信用卡）及其他支付必要信息，以实现其确认您的支付指令并完成支付，具体适用微信支付相应的隐私政策。'
    },{
      title:'',
      content:'e.商品或服务的交付'
    },{
      title:'',
      content:'在当您下单并选择当面付或在线完成支付，绿锋1688、绿锋1688的关联方、供应商、与绿锋1688合作的商家或第三方配送公司（以下称“配送公司”）将为您完成订单的交付。您知晓并同意，绿锋1688、绿锋1688的关联方、供应商、与绿锋1688合作的商家或配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。'
    },{
      title:'',
      content:'f.客服支持与售后服务'
    },{
      title:'',
      content:'我们的电话客服和售后功能会使用您的账号信息和订单信息。为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息与您核验您的身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更配送地址、联系人或联系电话。'
    },{
      title:'',
      content:'若您有货物要退换需先提出退货申请，为顺利退换货物，我们将收集或查询您购买商品的质保起止期、退换货商品快递公司、快递单号、退货地址、投递时间信息。'
    },{
      title:'',
      content:'2.您可自主选择提供的个人信息的情形'
    },{
      title:'',
      content:'为使您购物更便捷或更有乐趣，从而提升您在绿锋1688的网上购物体验，我们在扩展功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以进行网上购物，但您可能无法使用为您带来购物乐趣的扩展功能或在购买某些商品时需要重复填写一些信息。'
    },{
      title:'',
      content:'请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。'
    },{
      title:'',
      content:'3.我们从第三方获得您个人信息的情形'
    },{
      title:'',
      content:'我们可能从第三方获取您授权共享的账号信息（头像、昵称及授权页面提示的其他信息），并在您同意本隐私政策后将您的第三方账号与您的绿锋1688账号绑定，使您可以通过第三方账号直接登录并使用我们的产品或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。您也可以使用本机号码来快捷登录，我们会将您的网络信息提供给运营商完成注册或登录。'
    },{
      title:'',
      content:'4.请您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意'
    },{
      title:'',
      content:'a. 与犯罪侦查、起诉、审判和判决执行等直接相关的；'
    },{
      title:'',
      content:'b. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；'
    },{
      title:'',
      content:'c. 所收集的个人信息是个人信息主体自行向社会公众公开的；'
    },{
      title:'',
      content:'d. 根据个人信息主体要求签订和履行合同所必需的；'
    },{
      title:'',
      content:'e. 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；'
    },{
      title:'',
      content:'f. 用于维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。'
    },{
      title:'',
      content:'g. 与个人信息控制者履行法律法规规定的义务相关的；'
    },{
      title:'',
      content:'h. 与国家安全、国防安全直接相关的；'
    },{
      title:'',
      content:'i. 与公共安全、公共卫生、重大公共利益直接相关的；'
    },{
      title:'',
      content:'5.您个人信息使用的规则'
    },{
      title:'',
      content:'a.信息使用依据：我们会根据本隐私政策的约定并为实现我们的产品或服务功能对所收集的个人信息进行使用。'
    },{
      title:'',
      content:'b.去标识化处理及商业化利用：在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。'
    },{
      title:'',
      content:'c.持续授权：您在使用我们的产品或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息或对您的个人信息进行匿名化处理。'
    },{
      title:'',
      content:'d.统计信息共享：我们会对我们的产品或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。'
    },{
      title:'',
      content:'e.信息展示脱敏：当我们展示您的个人信息时，我们会对您的信息进行脱敏，以保护您的信息安全。'
    },{
      title:'',
      content:'f.用途变更同意：当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。'
    },{
      title:'二、我们如何使用 Cookies 和同类技术',
      content:'（一）Cookies的使用'
    },{
      title:'',
      content:'a.个性化联机体验：为实现您联机体验的个性化需求，使您获得更轻松的访问体验，我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件。这些指定给您的Cookies是唯一的，只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品数据以提供购物偏好设置、帮助您优化对广告的选择与互动、判断您的登录状态以及保障账号或数据安全。'
    },{
      title:'',
      content:'b.Cookies的管理与删除：我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可以根据自己的偏好管理或删除Cookies。您可以清除计算机上保存的所有Cookies，大部分网络浏览器会自动接受Cookies，但您通常可以根据需要修改浏览器设置以拒绝Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问绿锋1688网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。'
    },{
      title:'',
      content:'（二）其他同类技术的使用'
    },{
      title:'',
      content:'除 Cookie 外，我们可能还会在网站上使用其他同类技术。'
    },{
      title:'三、我们如何共享、转让、公开披露您的信息',
      content:'（一）共享'
    },{
      title:'',
      content:'a.事先获得明确的同意或授权：在未事先获得您明确的同意或授权的情况下，我们不会与任何第三方公司、组织或个人共享您的个人信息。'
    },{
      title:'',
      content:'b.法律法规及强制性要求：根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下，我们会提供您的个人信息。'
    },{
      title:'',
      content:'c.关联方共享：我们可能会将您的个人信息与我们的关联方共享，但仅会出于合法、正当、必要、特定且明确的目的，并且只会共享提供服务所必要的个人信息。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。'
    },{
      title:'',
      content:'d.合作伙伴共享：为了保障为您提供的服务顺利完成，我们可能会向合作伙伴及第三方共享您的订单信息、账户信息、设备信息以及位置信息。但我们仅会出于合法、正当、必要、特定且明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。合作伙伴包括商品或技术服务供应商（如物流、支付服务等）和第三方商家。'
    },{
      title:'',
      content:'e.保密协定：对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。'
    },{
      title:'',
      content:'f.法律执行及防止欺诈：为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护我们、您或其他绿锋1688客户的权利及其财产或安全，包括为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。'
    },{
      title:'',
      content:'（二）转让'
    },{
      title:'',
      content:'我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：'
    },{
      title:'',
      content:'a.事先获得明确的同意或授权：在未事先获得您明确的同意或授权的情况下，我们不会将您的个人信息转让给任何第三方。'
    },{
      title:'',
      content:'b.法律法规要求：根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供。'
    },{
      title:'',
      content:'c.相关协议约定：符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供。'
    },{
      title:'',
      content:'d.业务变动：在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。'
    },{
      title:'',
      content:'（三）公开披露'
    },{
      title:'',
      content:'我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：'
    },{
      title:'',
      content:'a.明确同意：根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息。'
    },{
      title:'',
      content:'b.法律法规要求：根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。'
    },{
      title:'四、我们如何保护和保存您的个人信息',
      content:'我们非常重视用户对其个人信息的管理权利，并为用户提供了多种途径和方式来查询、访问、修改、删除其个人信息。具体措施如下：'
    },{
      title:'',
      content:'（一）访问和更新您的个人信息'
    },{
      title:'',
      content:'a.账户信息：您可以在任何时候通过登录您的“绿锋1688”账户，访问并更新您的个人资料和账户信息。这包括您的姓名、联系方式、地址等基本信息。'
    },{
      title:'',
      content:'b.订单信息：您可以通过访问“我的订单”页面查看和管理您的订单历史记录，包括订单状态、物流信息和交易详情。'
    },{
      title:'',
      content:'（二）删除和注销您的个人信息'
    },{
      title:'',
      content:'a.删除个人信息：如果您希望删除您的某些个人信息，如浏览记录、订单信息等，您可以通过相应的功能页面进行操作。例如，您可以在“浏览记录”页面删除特定浏览记录，或在“我的订单”页面删除已完成的订单记录。'
    },{
      title:'',
      content:'b.注销账户：如果您决定不再使用“绿锋1688”服务并希望彻底删除您的账户和相关信息，您可以通过以下步骤申请注销账户：登录您的账户，找到并点击“注销账户”选项，根据提示完成身份验证，并确认注销请求。我们将在核实您的身份后，依法删除或匿名化处理您的个人信息，除非法律法规另有规定需要保留的信息。'
    },{
      title:'',
      content:'3.数据主体权利：根据适用的数据保护法律，您有权要求访问、更正、删除或限制处理您的个人信息。您可以通过本政策中提供的联系方式提出相关请求。我们会在收到您的请求后及时响应，并在合理时间内完成处理。'
    },{
      title:'',
      content:'请注意，即使您删除或注销了账户，某些信息可能会因为法律法规的要求或合理的业务需求而继续保留一段时间。此外，一旦信息被删除或匿名化处理后，将无法恢复。'
    },{
      title:'',
      content:'我们致力于保护用户的隐私和个人信息安全，并将持续改进我们的技术和措施，以确保您能够有效管理自己的个人信息。如果您对我们的个人信息管理有任何疑问或建议，请随时联系我们。'
    },{
      title:'五、您如何查阅及管理您的个人信息',
      content:'在“绿锋1688”，我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利。为了确保您能够充分管理和控制自己的个人信息，我们为您提供了以下几种方式：'
    },{
      title:'',
      content:'（一）访问和更正您的个人信息'
    },{
      title:'',
      content:'除法律法规规定外，您有权随时访问和更正您的个人信息。具体包括：'
    },{
      title:'',
      content:'账号信息：您可以修改个人头像、联系人、已绑定手机号、登录密码和绑定微信等。'
    },{
      title:'',
      content:'收货信息：您可以添加、删除或修改您的收货地址，并将最常用的地址设置为默认地址。'
    },{
      title:'',
      content:'订单信息：您可以查看和管理您的订单状态，包括待支付、发货中、待收货、已完成和退换售后等。'
    },{
      title:'',
      content:'对于您在使用我们的产品或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。'
    },{
      title:'',
      content:'（二）删除您的个人信息'
    },{
      title:'',
      content:'您可以直接在我们的产品或服务页面中清除或删除的信息，包括订单信息、浏览信息和收货地址信息。'
    },{
      title:'',
      content:'在以下情形中，您可以向我们提出删除个人信息的请求：'
    },{
      title:'',
      content:'a.如果我们处理个人信息的行为违反法律法规；'
    },{
      title:'',
      content:'b.如果我们收集、使用您的个人信息，却未征得您的同意；'
    },{
      title:'',
      content:'c.如果我们处理个人信息的行为严重违反了与您的约定；'
    },{
      title:'',
      content:'d.如果您不再使用我们的产品或服务，或您注销“绿锋1688”账号；'
    },{
      title:'',
      content:'e.如果我们终止服务及运营，或者保存期限已届满。'
    },{
      title:'',
      content:'若我们决定响应您的删除请求，我们还将同时通知从我们获得您个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体已获得您的独立授权。当您成功注销“绿锋1688”账号后，我们将对您的个人信息进行删除或匿名化处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到可以删除或实现匿名化。'
    },{
      title:'',
      content:'（三）改变您授权同意的范围或撤回您的授权'
    },{
      title:'',
      content:'您可以通过删除信息、关闭设备功能、在“绿锋1688”网站或软件中进行隐私设置改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。'
    },{
      title:'',
      content:'请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。'
    },{
      title:'',
      content:'（四）注销账号'
    },{
      title:'',
      content:'您可以在“绿锋1688”产品中直接申请注销账号。您可以通过移动端访问“我的-账号注销”完成账号注销。您注销账号后，我们将停止为您提供产品或服务，并根据适用法律的要求删除您的个人信息，或进行匿名化处理。'
    },{
      title:'',
      content:'（五）获取您的个人信息副本'
    },{
      title:'',
      content:'您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，请随时联系我们。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供相应的个人信息副本。'
    },{
      title:'',
      content:'（六）响应您的请求'
    },{
      title:'',
      content:'如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品或服务时所产生的其他个人信息，或您认为“绿锋1688”存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本隐私政策中的联系方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。'
    },{
      title:'',
      content:'在以下情形中，按照法律法规要求，我们将无法响应您的请求：'
    },{
      title:'',
      content:'a.与个人信息控制者履行法律法规规定的义务相关的；'
    },{
      title:'',
      content:'b.与国家安全、国防安全有关的；'
    },{
      title:'',
      content:'c.与公共安全、公共卫生、重大公共利益有关的；'
    },{
      title:'',
      content:'d.与犯罪侦查、起诉和审判等有关的；'
    },{
      title:'',
      content:'e.个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；'
    },{
      title:'',
      content:'f.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；'
    },{
      title:'',
      content:'g.响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；'
    },{
      title:'',
      content:'h.涉及商业秘密的。'
    },{
      title:'六、第三方 SDK 收集使用信息说明',
      content:'微信'
    },{
      title:'',
      content:'运营方：深圳市腾讯计算机系统有限公司。功能：用于实现微信登录、微信分享、微信小程序、微信支付。收集个人信息类型：设备信息（ IMSI 、 IMEI 、 MAC 地址、 AndroidID ）、位置信息、应用列表。'
    },{
      title:'',
      content:'隐私政策链接： https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy'
    },{
      title:'',
      content:'高德地图'
    },{
      title:'',
      content:'运营方：高德软件有限公司。功能：用于实现选择服务商距离查询。收集个人信息类型：位置信息（经纬度、精确位置、粗略位置）、设备信息【如 IP 地址、 GNSS 信息、 WIFI 状态、 WIFI 参数、 WIFI 列表、基站信息、信号强度的信息、蓝牙信息、传感器信息、设备信号、强度信息】、设备标识信息（ IMEI 、 IDFA 、 IDFV 、 AndroidID 、 MEID 、 MAC 地址、 OAID 、 IMSI 、硬件序列号）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统）。'
    },{
      title:'',
      content:'隐私政策链接： http://cache.amap.com/h5/h5/publish/238/index.html'
    },{
      title:'七、未成年人的个人信息保护',
      content:'我们的产品或服务主要面向企业或个体经营者。若您是18周岁以下的未成年人，在使用我们的产品或服务前，应事先取得您父母或法定监护人的书面同意。如果没有父母或监护人的同意，未成年人不应创建自己的用户账户。'
    },{
      title:'',
      content:'对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或公开披露此信息。'
    },{
      title:'',
      content:'如果有事实证明未成年人在未获得父母或法定监护人同意的情况下注册使用了我们的产品或服务，我们会与相关监护人协调，并设法尽快删除相关数据。'
    },{
      title:'八、本隐私政策如何更新',
      content:'为了给您提供更好的服务，绿锋1688的隐私政策会随着业务的发展不时更新。在更新生效前，我们会通过网站公告、弹窗或其他适当方式提醒您相关内容的更新，也请您定期访问我们的网站以便及时了解最新的隐私政策。对于重大变更，我们还会通过邮件、短信或在浏览页面做特别提示等方式，说明具体变更内容。未经您的明确同意，我们不会削减您依据本隐私政策所应享有的权利。'
    },{
      title:'九、如何联系我们',
      content:'您可以通过以下方式与我们联系，一般情况下，我们将在15天内回复。'
    },{
      title:'',
      content:'联系电话：020-36331287'
    },{
      title:'',
      content:'电子邮件：wanwukong@126.com'
    },{
      title:'',
      content:'如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商监管部门进行投诉或举报。'
    }]
  }
},
methods:{
},
}
</script>

<style scoped lang="scss">
.privacy-policy-box {
  min-height: 100vh;
  background: #fafafa;
  padding: 60px 15px 0;
  color: #222;
  .text {
    text-align: left;
    padding-bottom: 0px;
    word-break: break-all;
    .title {
      font-size: 18px;
      padding: 15px 0;
    }
    .content {
      padding: 10px 0;
    }
  }
}
</style>